import React, { useEffect, useMemo, useRef, useState } from 'react';
import PePapersDisclaimerGate from '../pe-papers/shared/PePapersDisclaimerGate';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { savePePapersArchiveDoc } from '../../services/pePapersArchiveService';
import useAppStore from '../../store/appStore';
import { usePersonalDataSelector } from '../../store/usePersonalDataSelector';
import { downloadHtmlAsPdf } from '../../utils/pe-papers/htmlDocumentPdfDownload';

const URLAUB_CONTRACT_PDF_CSS = `
  .av-a4-page {
    display: block !important;
    width: 100% !important;
    max-width: 210mm !important;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    color: #0f172a !important;
    font-size: 12px !important;
    line-height: 1.48 !important;
    padding: 11mm 13mm !important;
    background: #ffffff !important;
  }
  .av-a4-page * { box-sizing: border-box !important; }
  .av-a4-page .pdf-letterhead {
    width: 100% !important;
    text-align: center !important;
    border-bottom: 2px solid #1e293b !important;
    margin: 0 0 12px !important;
    padding: 0 0 10px !important;
  }
  .av-a4-page .pdf-letterhead h1 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 18px !important;
    font-weight: 900 !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase !important;
    color: #0f172a !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 0 3px !important;
    text-align: center !important;
  }
  .av-a4-page .pdf-letterhead h2 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 10.5px !important;
    font-weight: 700 !important;
    letter-spacing: 0.16em !important;
    text-transform: uppercase !important;
    color: #b48a56 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    text-align: center !important;
  }
  .av-meta-grid {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin: 0 0 12px !important;
    border: 1px solid #cbd5e1 !important;
    background: #f8fafc !important;
  }
  .av-meta-col {
    display: table-cell !important;
    width: 50% !important;
    vertical-align: top !important;
    padding: 10px 12px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #334155 !important;
    text-align: left !important;
  }
  .av-meta-col + .av-meta-col { border-left: 1px solid #e2e8f0 !important; }
  .av-meta-label {
    display: block !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.12em !important;
    color: #64748b !important;
    margin: 0 0 4px !important;
  }
  .av-meta-col strong { color: #0f172a !important; font-weight: 700 !important; }
  .av-meta-col p {
    width: 100% !important;
    margin: 0 !important;
    text-align: left !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #334155 !important;
  }
  .av-meta-col .av-meta-date {
    display: block !important;
    margin-top: 4px !important;
    color: #64748b !important;
    font-size: 11px !important;
  }
  .av-doc-section {
    display: block !important;
    width: 100% !important;
    margin: 0 0 12px !important;
  }
  .av-a4-page h3,
  .av-doc-section > h3 {
    display: block !important;
    width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11.5px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    text-align: left !important;
    background: #1e293b !important;
    color: #f8fafc !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 6px 10px !important;
    margin: 0 0 8px !important;
  }
  .av-a4-page p,
  .av-doc-p,
  .av-doc-section p {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    font-size: 12px !important;
    line-height: 1.48 !important;
    color: #1e293b !important;
    text-align: justify !important;
    margin: 0 0 8px !important;
  }
  .av-table-wrap {
    display: block !important;
    width: 100% !important;
    margin: 0 0 10px !important;
  }
  .av-table-wrap table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
    font-size: 12px !important;
  }
  .av-table-wrap thead th,
  .av-table-wrap th {
    background-color: #f1f5f9 !important;
    color: #0f172a !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.06em !important;
    padding: 5px 7px !important;
    border: 1px solid #e2e8f0 !important;
    border-bottom: 1px solid #cbd5e1 !important;
    text-align: left !important;
  }
  .av-table-wrap td {
    padding: 5px 7px !important;
    border: 1px solid #e2e8f0 !important;
    color: #334155 !important;
    text-align: left !important;
    vertical-align: middle !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 12px !important;
    line-height: 1.35 !important;
  }
  .ab-sig-table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
    margin-top: 24px !important;
    border: none !important;
  }
  .ab-sig-table td {
    width: 50% !important;
    vertical-align: top !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
  }
  .ab-sig-table p {
    text-align: left !important;
    margin: 0 !important;
    width: auto !important;
    max-width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .ab-sig-line-soft {
    display: block !important;
    width: 200px !important;
    max-width: 100% !important;
    border: none !important;
    border-bottom: 2px solid #1e293b !important;
    margin-top: 0 !important;
    margin-bottom: 6px !important;
    height: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }
  @media print {
    @page { size: A4; margin: 0; }
    body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    .av-a4-page {
      box-shadow: none !important;
      margin: 0 !important;
      max-width: none !important;
      width: 100% !important;
      min-height: 0 !important;
    }
  }
`;

const URLAUB_PRINT_CSS = `
${URLAUB_CONTRACT_PDF_CSS}
html, body {
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
}
`;

interface UrlaubskuerzungElternzeitModalProps {
    isOpen: boolean;
    onClose: () => void;
    initialData?: any;
    onArchived?: () => void;
}

interface BetriebFormData {
    firmenname: string;
    strasse: string;
    plz: string;
    ort: string;
}

interface MitarbeiterFormData {
    name: string;
    strasse: string;
    plz: string;
    ort: string;
}

interface BetriebFieldLocks {
    firmenname: boolean;
    strasse: boolean;
    plz: boolean;
    ort: boolean;
}

interface UrlaubsjahrEntry {
    jahr: number;
    volleKalendermonate: number;
    kuerzungstage: number;
    resturlaub: number;
}

interface UrlaubCalculation {
    jahre: UrlaubsjahrEntry[];
    volleKalendermonateGesamt: number;
}

type DauerOption = '' | '1' | '2' | '3' | 'individuell';

type TeamPool = 'produktiv' | 'unproduktiv' | 'azubi';

type TeamEmployeeOption = {
    id: string;
    name: string;
    pool: TeamPool;
    adresse: string;
};

const MONAT_OPTIONS: { value: string; label: string }[] = [
    { value: '1', label: 'Januar' },
    { value: '2', label: 'Februar' },
    { value: '3', label: 'März' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mai' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Dezember' },
];

const DAUER_OPTIONS: { value: Exclude<DauerOption, ''>; label: string; monate: number }[] = [
    { value: '1', label: '1 Jahr', monate: 12 },
    { value: '2', label: '2 Jahre', monate: 24 },
    { value: '3', label: '3 Jahre', monate: 36 },
    { value: 'individuell', label: 'Individuell (Monate)', monate: 0 },
];

const INITIAL_MITARBEITER_DATA: MitarbeiterFormData = {
    name: '',
    strasse: '',
    plz: '',
    ort: '',
};

const ELTERNZEIT_INFO_HINWEIS =
    '💡 Info für den Salonleiter: Du musst die Dauer nicht erraten. Schau in den schriftlichen Elternzeit-Antrag deines Mitarbeiters und trage die dort geforderten Monate/Jahre hier ein.';

const A4_PREVIEW_PAGE_CLASS =
    'av-a4-page bg-white text-slate-900 my-4 mx-auto w-full max-w-[210mm] h-auto min-h-0 shadow-xl rounded-sm text-left block overflow-visible print:my-0 print:shadow-none';

const DOC_P_CLASS = 'av-doc-p mb-2 text-justify text-slate-800 leading-relaxed';

const INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-input dark:bg-black text-pe-text dark:text-white px-4 py-2.5 text-sm focus:outline-none focus:border-[#E6C299]/50 transition-colors';

const LABEL_CLASS = 'text-xs font-semibold text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-1 block';

const READONLY_INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-elevated dark:bg-[#0a0a0a] text-pe-accent-text dark:text-[#E6C299] px-4 py-2.5 text-sm cursor-not-allowed opacity-90';

const ERROR_INPUT_RING = 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500/20';

const STEP_LABELS: Record<number, string> = {
    1: 'Datenerfassung & Berechnung',
    2: 'Vorschau & Export',
};

const isEmpty = (value: string) => !String(value || '').trim();

/** Legacy-Archiv / Stammdaten: einzeilige `adresse` → Straße / PLZ / Ort */
const parseLegacyMitarbeiterAdresse = (
    adresse: string
): Pick<MitarbeiterFormData, 'strasse' | 'plz' | 'ort'> => {
    const raw = String(adresse || '').trim();
    if (!raw) return { strasse: '', plz: '', ort: '' };

    const lines = raw
        .split(/[\n;]+/)
        .map((s) => s.trim())
        .filter(Boolean);

    const plzOrtMatch = (value: string) => {
        const m = value.match(/^(\d{4,5})\s+(.+)$/);
        return m ? { plz: m[1], ort: m[2].trim() } : null;
    };

    if (lines.length === 1) {
        const parts = lines[0]
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
        if (parts.length >= 2) {
            const last = plzOrtMatch(parts[parts.length - 1]);
            if (last) {
                return {
                    strasse: parts.slice(0, -1).join(', '),
                    plz: last.plz,
                    ort: last.ort,
                };
            }
        }
        const single = plzOrtMatch(lines[0]);
        if (single) return { strasse: '', ...single };
        return { strasse: lines[0], plz: '', ort: '' };
    }

    const lastLine = plzOrtMatch(lines[lines.length - 1]);
    if (lastLine) {
        return {
            strasse: lines.slice(0, -1).join(', '),
            plz: lastLine.plz,
            ort: lastLine.ort,
        };
    }
    return { strasse: lines[0], plz: '', ort: lines.slice(1).join(' ') };
};

const normalizeMitarbeiterData = (incoming: any): MitarbeiterFormData => {
    const src = incoming && typeof incoming === 'object' ? incoming : {};
    const hasStructured =
        !isEmpty(String(src.strasse || '')) ||
        !isEmpty(String(src.plz || '')) ||
        !isEmpty(String(src.ort || ''));
    if (!hasStructured && typeof src.adresse === 'string' && src.adresse.trim()) {
        const parsed = parseLegacyMitarbeiterAdresse(src.adresse);
        return {
            name: String(src.name || ''),
            strasse: parsed.strasse,
            plz: parsed.plz,
            ort: parsed.ort,
        };
    }
    return {
        name: String(src.name || ''),
        strasse: String(src.strasse || ''),
        plz: String(src.plz || ''),
        ort: String(src.ort || ''),
    };
};

const formatMitarbeiterAdresseInline = (data: MitarbeiterFormData): string => {
    const line1 = data.strasse.trim();
    const line2 = [data.plz.trim(), data.ort.trim()].filter(Boolean).join(' ');
    return [line1, line2].filter(Boolean).join(', ');
};

const formatTodayGerman = (): string => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
};

const formatDisplayDate = (value: string): string => {
    if (!value.trim()) return '____________';
    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) return `${isoMatch[3]}.${isoMatch[2]}.${isoMatch[1]}`;
    return value.trim();
};

const formatTage = (value: number): string => {
    if (!Number.isFinite(value)) return '____________';
    // ASCII-Komma, immer 2 Nachkommastellen (kein toLocaleString / keine Roh-Floats)
    return (Math.round(Number(value) * 100) / 100).toFixed(2).replace(/\./g, ',');
};

/** Eine saubere Formelzeile — "Tage" genau einmal am Ende */
const formatKuerzungsFormel = (monate: number, monatsFaktor: number, kuerzung: number): string =>
    `${monate} \u00d7 ${formatTage(monatsFaktor)} = ${formatTage(kuerzung)} Tage`;

const toIsoDate = (year: number, month: number, day: number): string =>
    `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

const getLastDayOfMonth = (year: number, month: number): number => new Date(year, month, 0).getDate();

const buildJahrOptions = (): { value: string; label: string }[] => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 4 }, (_, index) => {
        const year = currentYear + index;
        return { value: String(year), label: String(year) };
    });
};

const computeElternzeitZeitraum = (
    startMonat: number,
    startJahr: number,
    durationMonths: number
): { beginn: string; ende: string; volleKalendermonateGesamt: number } | null => {
    if (startMonat < 1 || startMonat > 12 || durationMonths < 1) return null;

    const beginn = toIsoDate(startJahr, startMonat, 1);

    let endMonth = startMonat + durationMonths - 1;
    let endYear = startJahr;
    while (endMonth > 12) {
        endMonth -= 12;
        endYear += 1;
    }

    const ende = toIsoDate(endYear, endMonth, getLastDayOfMonth(endYear, endMonth));
    const startDate = parseIsoDate(beginn);
    const endDate = parseIsoDate(ende);
    if (!startDate || !endDate) return null;

    return {
        beginn,
        ende,
        volleKalendermonateGesamt: countFullCalendarMonths(startDate, endDate),
    };
};

const getDurationMonths = (dauerOption: DauerOption, individuelleMonate: string): number | null => {
    if (dauerOption === '1') return 12;
    if (dauerOption === '2') return 24;
    if (dauerOption === '3') return 36;
    if (dauerOption === 'individuell') {
        const custom = Number(individuelleMonate);
        if (!Number.isFinite(custom) || custom < 1) return null;
        return Math.floor(custom);
    }
    return null;
};

const parseIsoDate = (value: string): Date | null => {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (Number.isNaN(date.getTime())) return null;
    return date;
};

const countFullCalendarMonths = (startDate: Date, endDate: Date): number => {
    if (endDate < startDate) return 0;

    let count = 0;
    let year = startDate.getFullYear();
    let month = startDate.getMonth();
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();

    while (year < endYear || (year === endYear && month <= endMonth)) {
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);

        if (startDate <= firstDay && endDate >= lastDay) {
            count += 1;
        }

        month += 1;
        if (month > 11) {
            month = 0;
            year += 1;
        }
    }

    return count;
};

const calculateUrlaubKuerzung = (
    jahresurlaubTage: number,
    elternzeitBeginn: string,
    elternzeitEnde: string
): UrlaubCalculation | null => {
    if (jahresurlaubTage <= 0 || isEmpty(elternzeitBeginn) || isEmpty(elternzeitEnde)) return null;

    const startDate = parseIsoDate(elternzeitBeginn);
    const endDate = parseIsoDate(elternzeitEnde);
    if (!startDate || !endDate || endDate < startDate) return null;

    const monatsAnteil = jahresurlaubTage / 12;
    const jahre: UrlaubsjahrEntry[] = [];

    for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year += 1) {
        const yearRangeStart = new Date(year, 0, 1);
        const yearRangeEnd = new Date(year, 11, 31);
        const sliceStart = startDate > yearRangeStart ? startDate : yearRangeStart;
        const sliceEnd = endDate < yearRangeEnd ? endDate : yearRangeEnd;

        if (sliceEnd < sliceStart) continue;

        const volleKalendermonate = countFullCalendarMonths(sliceStart, sliceEnd);
        if (volleKalendermonate <= 0) continue;

        const kuerzungstage = Math.round(volleKalendermonate * monatsAnteil * 100) / 100;
        const resturlaub = Math.round(Math.max(0, jahresurlaubTage - kuerzungstage) * 100) / 100;

        jahre.push({ jahr: year, volleKalendermonate, kuerzungstage, resturlaub });
    }

    if (jahre.length === 0) return null;

    const volleKalendermonateGesamt = countFullCalendarMonths(startDate, endDate);

    return { jahre, volleKalendermonateGesamt };
};

const formatUrlaubsjahreSummary = (jahre: UrlaubsjahrEntry[]): string =>
    jahre
        .map(
            (entry) =>
                `${entry.jahr}: ${entry.volleKalendermonate} Mon. → Kürzung ${formatTage(entry.kuerzungstage)} T., Rest ${formatTage(entry.resturlaub)} T.`
        )
        .join(' | ');

const buildBetriebFromClient = (clientData: any): { betrieb: BetriebFormData; locks: BetriebFieldLocks } => {
    const firmenname = clientData?.salonname || clientData?.firmenname || '';
    const strasse = clientData?.strasse || '';
    const plz = clientData?.plz || '';
    const ort = clientData?.ort || '';

    return {
        betrieb: { firmenname, strasse, plz, ort },
        locks: {
            firmenname: !isEmpty(firmenname),
            strasse: !isEmpty(strasse),
            plz: !isEmpty(plz),
            ort: !isEmpty(ort),
        },
    };
};

const UrlaubskuerzungElternzeitModal: React.FC<UrlaubskuerzungElternzeitModalProps> = ({
    isOpen,
    onClose,
    initialData,
    onArchived,
}) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [jahresurlaubTage, setJahresurlaubTage] = useState('');
    const [startMonat, setStartMonat] = useState('');
    const [startJahr, setStartJahr] = useState('');
    const [dauerOption, setDauerOption] = useState<DauerOption>('');
    const [individuelleMonate, setIndividuelleMonate] = useState('');
    const [ergaenzenderFreitext, setErgaenzenderFreitext] = useState('');
    const [betriebData, setBetriebData] = useState<BetriebFormData>({
        firmenname: '',
        strasse: '',
        plz: '',
        ort: '',
    });
    const [betriebLocks, setBetriebLocks] = useState<BetriebFieldLocks>({
        firmenname: false,
        strasse: false,
        plz: false,
        ort: false,
    });
    const [mitarbeiterData, setMitarbeiterData] = useState<MitarbeiterFormData>(INITIAL_MITARBEITER_DATA);
    const [selectedTeamEmployeeId, setSelectedTeamEmployeeId] = useState('');
    const [invalidFields, setInvalidFields] = useState<Set<string>>(new Set());
    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [archiveFeedback, setArchiveFeedback] = useState<'idle' | 'success' | 'error' | 'draft'>('idle');
    const [archiveDocId, setArchiveDocId] = useState<string | null>(null);

    const printContainerRef = useRef<HTMLDivElement>(null);

    const clientData = useAppStore((state: any) => state.clientData);
    const { personalData, unproductivePersonalData, azubiAssistenzData } = usePersonalDataSelector();
    const jahrOptions = useMemo(() => buildJahrOptions(), []);

    const teamEmployees = useMemo((): TeamEmployeeOption[] => {
        const mapPool = (list: any[], pool: TeamPool): TeamEmployeeOption[] =>
            (Array.isArray(list) ? list : [])
                .filter((emp) => emp?.id)
                .map((emp) => ({
                    id: String(emp.id),
                    name: String(emp.name || '').trim() || 'Ohne Name',
                    pool,
                    adresse: String(emp.adresse || emp.info || '').trim(),
                }));
        return [
            ...mapPool(personalData, 'produktiv'),
            ...mapPool(unproductivePersonalData, 'unproduktiv'),
            ...mapPool(azubiAssistenzData, 'azubi'),
        ];
    }, [personalData, unproductivePersonalData, azubiAssistenzData]);

    const elternzeitZeitraum = useMemo(() => {
        const monat = Number(startMonat);
        const jahr = Number(startJahr);
        const durationMonths = getDurationMonths(dauerOption, individuelleMonate);
        if (!monat || !jahr || !durationMonths) return null;
        return computeElternzeitZeitraum(monat, jahr, durationMonths);
    }, [startMonat, startJahr, dauerOption, individuelleMonate]);

    const elternzeitBeginn = elternzeitZeitraum?.beginn ?? '';
    const elternzeitEnde = elternzeitZeitraum?.ende ?? '';

    const urlaubCalculation = useMemo(() => {
        const jahresurlaub = Number(jahresurlaubTage);
        if (!Number.isFinite(jahresurlaub) || jahresurlaub <= 0 || !elternzeitZeitraum) return null;
        return calculateUrlaubKuerzung(jahresurlaub, elternzeitZeitraum.beginn, elternzeitZeitraum.ende);
    }, [jahresurlaubTage, elternzeitZeitraum]);

    useEffect(() => {
        if (!isOpen) {
            setCurrentStep(1);
            setJahresurlaubTage('');
            setStartMonat('');
            setStartJahr('');
            setDauerOption('');
            setIndividuelleMonate('');
            setErgaenzenderFreitext('');
            setMitarbeiterData(INITIAL_MITARBEITER_DATA);
            setSelectedTeamEmployeeId('');
            setInvalidFields(new Set());
            setDisclaimerAccepted(false);
            setIsSaving(false);
            setArchiveFeedback('idle');
            setArchiveDocId(null);
            return;
        }

        const { betrieb, locks } = buildBetriebFromClient(clientData);
        setBetriebData(betrieb);
        setBetriebLocks(locks);
        setCurrentStep(1);
        setJahresurlaubTage('');
        setStartMonat('');
        setStartJahr('');
        setDauerOption('');
        setIndividuelleMonate('');
        setErgaenzenderFreitext('');
        setMitarbeiterData(INITIAL_MITARBEITER_DATA);
        setSelectedTeamEmployeeId('');
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        setArchiveDocId(initialData?.id || null);

        if (initialData) {
            if (initialData.jahresurlaubTage != null && initialData.jahresurlaubTage !== '') {
                setJahresurlaubTage(String(initialData.jahresurlaubTage));
            }
            if (initialData.startMonat != null && initialData.startMonat !== '') {
                setStartMonat(String(initialData.startMonat));
            }
            if (initialData.startJahr != null && initialData.startJahr !== '') {
                setStartJahr(String(initialData.startJahr));
            }
            const dauer = initialData.dauerOption;
            if (dauer === '1' || dauer === '2' || dauer === '3' || dauer === 'individuell') {
                setDauerOption(dauer);
            }
            if (initialData.individuelleMonate != null && initialData.individuelleMonate !== '') {
                setIndividuelleMonate(String(initialData.individuelleMonate));
            }
            if (typeof initialData.ergaenzenderFreitext === 'string') {
                setErgaenzenderFreitext(initialData.ergaenzenderFreitext);
            }
            if (initialData.betriebData && typeof initialData.betriebData === 'object') {
                setBetriebData({ ...betrieb, ...initialData.betriebData });
                setBetriebLocks({
                    firmenname: !isEmpty(String(initialData.betriebData.firmenname ?? betrieb.firmenname)),
                    strasse: !isEmpty(String(initialData.betriebData.strasse ?? betrieb.strasse)),
                    plz: !isEmpty(String(initialData.betriebData.plz ?? betrieb.plz)),
                    ort: !isEmpty(String(initialData.betriebData.ort ?? betrieb.ort)),
                });
            }
            if (initialData.mitarbeiterData && typeof initialData.mitarbeiterData === 'object') {
                setMitarbeiterData(normalizeMitarbeiterData(initialData.mitarbeiterData));
            }
            if (typeof initialData.selectedTeamEmployeeId === 'string') {
                setSelectedTeamEmployeeId(initialData.selectedTeamEmployeeId);
            }
            const step = Number(initialData.currentStep);
            if (Number.isFinite(step) && step >= 1 && step <= 2) {
                setCurrentStep(step);
            }
            if (initialData.confirmedDisclaimer) {
                setDisclaimerAccepted(true);
            }
        }
    }, [isOpen, clientData, initialData]);

    const validateStep1 = (): string[] => {
        const errors: string[] = [];

        if (isEmpty(betriebData.firmenname)) errors.push('betrieb_firmenname');
        if (isEmpty(betriebData.strasse)) errors.push('betrieb_strasse');
        if (isEmpty(betriebData.plz)) errors.push('betrieb_plz');
        if (isEmpty(betriebData.ort)) errors.push('betrieb_ort');
        if (isEmpty(mitarbeiterData.name)) errors.push('mitarbeiter_name');
        if (isEmpty(mitarbeiterData.strasse)) errors.push('mitarbeiter_strasse');
        if (isEmpty(mitarbeiterData.plz)) errors.push('mitarbeiter_plz');
        if (isEmpty(mitarbeiterData.ort)) errors.push('mitarbeiter_ort');

        const jahresurlaub = Number(jahresurlaubTage);
        if (!jahresurlaubTage.trim() || !Number.isFinite(jahresurlaub) || jahresurlaub <= 0) {
            errors.push('jahresurlaub_tage');
        }
        if (!startMonat) errors.push('elternzeit_start_monat');
        if (!startJahr) errors.push('elternzeit_start_jahr');
        if (!dauerOption) errors.push('elternzeit_dauer');
        if (dauerOption === 'individuell') {
            const custom = Number(individuelleMonate);
            if (!individuelleMonate.trim() || !Number.isFinite(custom) || custom < 1) {
                errors.push('elternzeit_individuell_monate');
            }
        }

        if (!urlaubCalculation) {
            if (!errors.includes('jahresurlaub_tage')) errors.push('jahresurlaub_tage');
            if (!errors.includes('elternzeit_start_monat')) errors.push('elternzeit_start_monat');
            if (!errors.includes('elternzeit_start_jahr')) errors.push('elternzeit_start_jahr');
            if (!errors.includes('elternzeit_dauer')) errors.push('elternzeit_dauer');
            if (dauerOption === 'individuell' && !errors.includes('elternzeit_individuell_monate')) {
                errors.push('elternzeit_individuell_monate');
            }
        }

        return errors;
    };

    const isFieldInvalid = (field: string) => invalidFields.has(field);

    const getInputClass = (baseClass: string, field: string) =>
        isFieldInvalid(field) ? `${baseClass} ${ERROR_INPUT_RING}` : baseClass;

    const clearFieldError = (field: string) => {
        setInvalidFields((prev) => {
            if (!prev.has(field)) return prev;
            const next = new Set(prev);
            next.delete(field);
            return next;
        });
    };

    const updateBetriebField = <K extends keyof BetriebFormData>(key: K, value: BetriebFormData[K]) => {
        setBetriebData((prev) => ({ ...prev, [key]: value }));
        clearFieldError(`betrieb_${key}`);
    };

    const updateMitarbeiterField = <K extends keyof MitarbeiterFormData>(key: K, value: MitarbeiterFormData[K]) => {
        setMitarbeiterData((prev) => ({ ...prev, [key]: value }));
        clearFieldError(`mitarbeiter_${key}`);
    };

    const handleTeamEmployeeSelect = (employeeId: string) => {
        setSelectedTeamEmployeeId(employeeId);
        if (!employeeId) return;
        const emp = teamEmployees.find((e) => e.id === employeeId);
        if (!emp) return;
        const parsedAdresse = parseLegacyMitarbeiterAdresse(emp.adresse);
        setMitarbeiterData({
            name: emp.name === 'Ohne Name' ? '' : emp.name,
            strasse: parsedAdresse.strasse,
            plz: parsedAdresse.plz,
            ort: parsedAdresse.ort,
        });
        clearFieldError('mitarbeiter_name');
        clearFieldError('mitarbeiter_strasse');
        clearFieldError('mitarbeiter_plz');
        clearFieldError('mitarbeiter_ort');
    };

    const renderFieldError = (field: string) =>
        isFieldInvalid(field) ? (
            <p className="text-[10px] text-red-400 mt-1">Dieses Feld ist erforderlich</p>
        ) : null;

    const betriebAutoComplete: Record<keyof BetriebFormData, string> = {
        firmenname: 'organization',
        strasse: 'street-address',
        plz: 'postal-code',
        ort: 'address-level2',
    };

    const renderBetriebField = (field: keyof BetriebFormData, label: string) => {
        const lockKey = field as keyof BetriebFieldLocks;
        const fieldId = `betrieb_${field}`;
        const isLocked = betriebLocks[lockKey];

        return (
            <div>
                <label className={LABEL_CLASS} htmlFor={`urlaub-${fieldId}`}>
                    {label}
                </label>
                <input
                    id={`urlaub-${fieldId}`}
                    type="text"
                    name={field}
                    autoComplete={isLocked ? 'off' : betriebAutoComplete[field]}
                    value={betriebData[field]}
                    readOnly={isLocked}
                    onChange={(e) => !isLocked && updateBetriebField(field, e.target.value)}
                    className={getInputClass(isLocked ? READONLY_INPUT_CLASS : INPUT_CLASS, fieldId)}
                />
                {renderFieldError(fieldId)}
            </div>
        );
    };

    const renderLocalDocument = () => {
        if (!urlaubCalculation) return null;

        const { jahre } = urlaubCalculation;
        const jahresurlaub = Number(jahresurlaubTage);
        const monatsAnteil = jahresurlaub / 12;
        const ortDatum = `${betriebData.ort || '____________'}, ${formatTodayGerman()}`;
        const mitarbeiterNameDoc = mitarbeiterData.name || '____________';

        return (
            <div className={`${A4_PREVIEW_PAGE_CLASS} min-h-[297mm]`}>
                <div className="pdf-letterhead text-center">
                    <h1>Urlaubskürzung Elternzeit</h1>
                    <h2>PreisExpert · PEPapers · § 17 Abs. 1 BEEG</h2>
                </div>

                <div className="av-meta-grid">
                    <div className="av-meta-col">
                        <p className="av-meta-label">Arbeitgeber</p>
                        <p>
                            <strong>{betriebData.firmenname || '____________'}</strong>
                            {betriebData.strasse ? (
                                <>
                                    <br />
                                    {betriebData.strasse}
                                </>
                            ) : null}
                            {betriebData.plz || betriebData.ort ? (
                                <>
                                    <br />
                                    {[betriebData.plz, betriebData.ort].filter(Boolean).join(' ')}
                                </>
                            ) : null}
                            <span className="av-meta-date">Datum: {formatTodayGerman()}</span>
                        </p>
                    </div>
                    <div className="av-meta-col">
                        <p className="av-meta-label">Arbeitnehmer/in</p>
                        <p>
                            <strong>{mitarbeiterNameDoc}</strong>
                            {mitarbeiterData.strasse ? (
                                <>
                                    <br />
                                    {mitarbeiterData.strasse}
                                </>
                            ) : null}
                            {mitarbeiterData.plz || mitarbeiterData.ort ? (
                                <>
                                    <br />
                                    {[mitarbeiterData.plz, mitarbeiterData.ort].filter(Boolean).join(' ')}
                                </>
                            ) : !mitarbeiterData.strasse ? (
                                <>
                                    <br />
                                    ____________
                                </>
                            ) : null}
                        </p>
                    </div>
                </div>

                <div className="av-doc-section">
                    <h3>Mitteilung</h3>
                    <p className={DOC_P_CLASS}>
                        Sehr geehrte/r Frau/Herr <strong>{mitarbeiterNameDoc}</strong>,
                    </p>
                    <p className={DOC_P_CLASS}>
                        hiermit teilen wir Ihnen mit, dass Ihr Jahresurlaubsanspruch aufgrund Ihrer Elternzeit gemäß §
                        17 Abs. 1 Bundeselterngeld- und Elternzeitgesetz (BEEG) gekürzt wird.
                    </p>
                    <p className={DOC_P_CLASS}>
                        Ihre Elternzeit beginnt am <strong>{formatDisplayDate(elternzeitBeginn)}</strong> und endet am{' '}
                        <strong>{formatDisplayDate(elternzeitEnde)}</strong>. Die Urlaubskürzung wird für jedes
                        betroffene Kalenderjahr (Urlaubsjahr) separat berechnet. Berücksichtigt werden ausschließlich
                        volle Kalendermonate (vom 1. bis zum letzten Tag des jeweiligen Monats) innerhalb des jeweiligen
                        Jahres.
                    </p>
                    <p className={DOC_P_CLASS}>
                        Regulärer Jahresurlaubsanspruch: <strong>{formatTage(jahresurlaub)}</strong> Tage
                    </p>
                </div>

                <div className="av-doc-section">
                    <h3>Berechnung</h3>
                    <div className="av-table-wrap">
                        <table>
                            <colgroup>
                                <col style={{ width: '14%' }} />
                                <col style={{ width: '14%' }} />
                                <col style={{ width: '48%' }} />
                                <col style={{ width: '24%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Urlaubsjahr</th>
                                    <th>Volle Monate</th>
                                    <th>Kürzungstage</th>
                                    <th>Resturlaub</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jahre.map((entry) => (
                                    <tr key={entry.jahr}>
                                        <td>
                                            <strong>{entry.jahr}</strong>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <strong>{entry.volleKalendermonate}</strong>
                                        </td>
                                        <td style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
                                            {formatKuerzungsFormel(
                                                entry.volleKalendermonate,
                                                monatsAnteil,
                                                entry.kuerzungstage
                                            )}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'right',
                                                fontFamily: 'Arial, Helvetica, sans-serif',
                                            }}
                                        >
                                            {`${formatTage(entry.resturlaub)} Tage`}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <p className={DOC_P_CLASS}>
                        Die Kürzung erfolgt je Urlaubsjahr nach der gesetzlichen Formel: Anzahl der vollen
                        Kalendermonate der Elternzeit im jeweiligen Kalenderjahr multipliziert mit einem Zwölftel Ihres
                        Jahresurlaubsanspruchs.{' '}
                        <span style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {
                                'Der verbleibende Resturlaub je Jahr kann \u2013 soweit betrieblich m\u00f6glich \u2013 noch vor Beginn oder nach Ende Ihrer Elternzeit genommen werden.'
                            }
                        </span>
                    </p>
                </div>

                {!isEmpty(ergaenzenderFreitext) ? (
                    <div className="av-doc-section">
                        <h3>Ergänzende Hinweise</h3>
                        <p className={`${DOC_P_CLASS} whitespace-pre-wrap`}>{ergaenzenderFreitext}</p>
                    </div>
                ) : null}

                <table
                    className="ab-sig-table"
                    style={{
                        width: '100%',
                        marginTop: '24px',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed',
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ width: '50%', paddingRight: '20px', verticalAlign: 'top' }}>
                                <p style={{ margin: 0, fontSize: '11px', color: '#475569' }}>
                                    Ort, Datum: {ortDatum}
                                </p>
                                <div style={{ height: '36px' }} aria-hidden="true" />
                                <div
                                    style={{
                                        height: '1px',
                                        backgroundColor: '#1e293b',
                                        width: '200px',
                                        maxWidth: '100%',
                                        marginBottom: '6px',
                                    }}
                                    aria-hidden="true"
                                />
                                <p style={{ margin: 0, fontSize: '11px', fontWeight: 600, color: '#0f172a' }}>
                                    Unterschrift Arbeitgeber/in
                                </p>
                                <p style={{ margin: 0, fontSize: '11px', color: '#64748b' }}>
                                    {betriebData.firmenname || 'Arbeitgeber'}
                                </p>
                            </td>
                            <td style={{ width: '50%', paddingLeft: '20px', verticalAlign: 'top' }}>
                                <p style={{ margin: 0, fontSize: '11px', color: '#475569' }}>
                                    Kenntnis genommen am: ________________________
                                </p>
                                <div style={{ height: '36px' }} aria-hidden="true" />
                                <div
                                    style={{
                                        height: '1px',
                                        backgroundColor: '#1e293b',
                                        width: '200px',
                                        maxWidth: '100%',
                                        marginBottom: '6px',
                                    }}
                                    aria-hidden="true"
                                />
                                <p style={{ margin: 0, fontSize: '11px', fontWeight: 600, color: '#0f172a' }}>
                                    Unterschrift Arbeitnehmer/in
                                </p>
                                <p style={{ margin: 0, fontSize: '11px', color: '#64748b' }}>
                                    {mitarbeiterData.name || 'Arbeitnehmer/in'}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const renderContractDocument = () => (
        <div ref={printContainerRef} id="pepapers-urlaubskuerzung-print" className="w-full h-auto overflow-visible">
            <style>{URLAUB_CONTRACT_PDF_CSS}</style>
            {renderLocalDocument()}
        </div>
    );

    const handleWeiter = () => {
        const errors = validateStep1();
        if (errors.length > 0) {
            setInvalidFields(new Set(errors));
            return;
        }
        if (!urlaubCalculation) return;

        setInvalidFields(new Set());
        setCurrentStep(2);
    };

    const handleZurueck = () => {
        setInvalidFields(new Set());
        setCurrentStep(1);
    };

    const handleClose = () => {
        setCurrentStep(1);
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        onClose();
    };

    const isActionLocked = !disclaimerAccepted;

    const getActionButtonClass = (baseClass: string) =>
        `${baseClass} ${isActionLocked ? 'opacity-50 cursor-not-allowed' : ''}`;

    const getPrintHtml = () =>
        printContainerRef.current?.innerHTML ||
        document.getElementById('pepapers-urlaubskuerzung-print')?.innerHTML ||
        '';

    const handleDownloadPdf = async () => {
        if (isActionLocked || isPdfDownloading) return;
        const html = getPrintHtml();
        if (!html.trim()) {
            window.alert('Dokumentinhalt fehlt — bitte Vorschau prüfen.');
            return;
        }
        setIsPdfDownloading(true);
        try {
            const dateIso = new Date().toISOString().slice(0, 10);
            await downloadHtmlAsPdf({
                html,
                filename: `Urlaubskuerzung_Elternzeit_${dateIso}.pdf`,
                scrubMode: 'minimal',
                splitPrintBreaks: true,
                capturePadPx: 0,
                letterheadOnBreaks: false,
                extraCss: URLAUB_CONTRACT_PDF_CSS,
            });
        } catch (err: unknown) {
            console.error('PEPapers Urlaubskürzung PDF-Download fehlgeschlagen:', err);
            const message = err instanceof Error ? err.message : 'Unbekannter Fehler';
            window.alert('PDF konnte nicht heruntergeladen werden: ' + message);
        } finally {
            setIsPdfDownloading(false);
        }
    };

    const handlePrintIsolated = () => {
        if (isActionLocked || isPdfDownloading) return;

        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const printWindow = iframe.contentWindow;
        if (!printWindow) {
            document.body.removeChild(iframe);
            return;
        }

        const doc = printWindow.document;
        const printContent = getPrintHtml();

        doc.open();
        doc.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Urlaubskürzung Elternzeit</title>
      <style>${URLAUB_PRINT_CSS}</style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `);
        doc.close();

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            setTimeout(() => {
                if (iframe.parentNode) {
                    document.body.removeChild(iframe);
                }
            }, 1000);
        }, 500);
    };

    const handleArchive = async (asDraft = false) => {
        if (isSaving) return;
        if (!asDraft && isActionLocked) return;

        setIsSaving(true);
        setArchiveFeedback('idle');

        const htmlContent =
            printContainerRef.current?.innerHTML ||
            document.getElementById('pepapers-urlaubskuerzung-print')?.innerHTML ||
            '';

        try {
            const id = await savePePapersArchiveDoc({
                id: archiveDocId,
                documentType: 'urlaubskuerzung-elternzeit',
                status: asDraft ? 'entwurf' : 'final',
                salonName: betriebData.firmenname || 'Unbekannter Salon',
                mitarbeiterName: mitarbeiterData.name.trim(),
                confirmedDisclaimer: asDraft ? disclaimerAccepted : true,
                currentStep,
                payload: {
                    jahresurlaubTage: Number(jahresurlaubTage),
                    elternzeitBeginn,
                    elternzeitEnde,
                    startMonat,
                    startJahr,
                    dauerOption,
                    individuelleMonate,
                    volleKalendermonateGesamt: urlaubCalculation?.volleKalendermonateGesamt ?? 0,
                    urlaubsjahre: urlaubCalculation?.jahre ?? [],
                    ergaenzenderFreitext,
                    betriebData,
                    mitarbeiterData: {
                        ...mitarbeiterData,
                        adresse: formatMitarbeiterAdresseInline(mitarbeiterData),
                    },
                    selectedTeamEmployeeId: selectedTeamEmployeeId || null,
                    generatedHtml: htmlContent,
                },
            });
            setArchiveDocId(id);
            setArchiveFeedback(asDraft ? 'draft' : 'success');
            onArchived?.();
            if (asDraft) {
                setTimeout(() => {
                    onClose();
                }, 600);
            } else {
                setTimeout(() => setArchiveFeedback('idle'), 3000);
            }
        } catch (error) {
            console.error('PEPapers Urlaubskürzung Archivierung fehlgeschlagen:', error);
            setArchiveFeedback('error');
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;

    const modalWidthClass = currentStep === 2 ? 'max-w-4xl' : 'max-w-lg';

    return createPortal(
        <>
            <div
                className="fixed inset-0 bg-stone-900/70 dark:bg-black/90 z-[100000] backdrop-blur-md print:hidden"
                onClick={handleClose}
                aria-hidden="true"
            />
            <div className="fixed inset-x-0 top-[8.5rem] md:top-36 bottom-0 z-[100001] flex items-start justify-center overflow-hidden p-4 pb-8 font-sans print:inset-0 print:top-0 print:overflow-visible print:p-0">
                <div
                    className={`bg-pe-card dark:bg-[#111] rounded-2xl shadow-[0_0_40px_rgba(230,194,153,0.1)] border border-[#E6C299]/30 w-full ${modalWidthClass} max-h-[calc(100vh-9.5rem)] md:max-h-[calc(100vh-10rem)] flex min-h-0 flex-col justify-between overflow-hidden relative transition-all duration-200 my-2 print:shadow-none print:border-0 print:max-w-none print:max-h-none print:rounded-none print:my-0 print:bg-white`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        type="button"
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-pe-muted dark:text-slate-400 hover:text-pe-text dark:hover:text-white bg-pe-elevated dark:bg-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-[#222] rounded-lg p-2 transition-colors border border-pe-border-strong dark:border-[#333] z-[60] print:hidden"
                        aria-label="Schließen"
                    >
                        <X className="w-4 h-4" />
                    </button>

                    <div className="bg-pe-elevated dark:bg-[#111622] z-50 shrink-0 print:hidden border-b border-pe-border dark:border-[#222]">
                        <div className="px-6 pt-10 pb-4">
                            <h3 className="text-lg font-bold text-pe-accent-text dark:text-[#E6C299] text-center uppercase tracking-widest pr-8">
                                Urlaubskürzung Elternzeit
                            </h3>
                            <p className="text-center text-xs text-pe-muted dark:text-slate-400 uppercase tracking-widest mt-2">
                                Schritt {currentStep} von 2: {STEP_LABELS[currentStep]}
                            </p>
                        </div>
                    </div>

                    <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5 custom-scrollbar print:p-0 print:overflow-visible">
                        {currentStep === 1 && (
                            <div className="space-y-6">
                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Betriebsdaten
                                    </p>
                                    <div className="space-y-4">
                                        {renderBetriebField('firmenname', 'Firma / Salonname')}
                                        {renderBetriebField('strasse', 'Straße & Hausnummer')}
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            {renderBetriebField('plz', 'PLZ')}
                                            <div className="sm:col-span-2">{renderBetriebField('ort', 'Ort')}</div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Mitarbeiter-Daten
                                    </p>
                                    <div className="space-y-4">
                                        <div>
                                            <label className={LABEL_CLASS}>Aus Team wählen (optional)</label>
                                            <select
                                                value={selectedTeamEmployeeId}
                                                onChange={(e) => handleTeamEmployeeSelect(e.target.value)}
                                                className={INPUT_CLASS}
                                            >
                                                <option value="">— Manuell eintragen / Ex-Mitarbeiter —</option>
                                                {teamEmployees.map((emp) => (
                                                    <option key={`${emp.pool}-${emp.id}`} value={emp.id}>
                                                        {emp.name}
                                                        {emp.pool === 'azubi'
                                                            ? ' (Azubi/Assistenz)'
                                                            : emp.pool === 'unproduktiv'
                                                              ? ' (unproduktiv)'
                                                              : ''}
                                                    </option>
                                                ))}
                                            </select>
                                            {teamEmployees.length === 0 ? (
                                                <p className="mt-1 text-[10px] text-pe-muted dark:text-slate-500">
                                                    Keine Personaldaten hinterlegt – Name und Adresse manuell
                                                    eintragen.
                                                </p>
                                            ) : (
                                                <p className="mt-1 text-[10px] text-pe-muted dark:text-slate-500">
                                                    Auswahl füllt Name und Adresse vor; für Ex-Mitarbeiter einfach
                                                    manuell lassen. Felder bleiben danach editierbar.
                                                </p>
                                            )}
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS} htmlFor="urlaub-mitarbeiter-name">
                                                Name des Mitarbeiters
                                            </label>
                                            <input
                                                id="urlaub-mitarbeiter-name"
                                                type="text"
                                                name="name"
                                                autoComplete="name"
                                                value={mitarbeiterData.name}
                                                onChange={(e) => updateMitarbeiterField('name', e.target.value)}
                                                className={getInputClass(INPUT_CLASS, 'mitarbeiter_name')}
                                            />
                                            {renderFieldError('mitarbeiter_name')}
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS} htmlFor="urlaub-mitarbeiter-strasse">
                                                Straße &amp; Hausnummer
                                            </label>
                                            <input
                                                id="urlaub-mitarbeiter-strasse"
                                                type="text"
                                                name="strasse"
                                                autoComplete="street-address"
                                                value={mitarbeiterData.strasse}
                                                onChange={(e) => updateMitarbeiterField('strasse', e.target.value)}
                                                placeholder="z. B. Musterstraße 12"
                                                className={getInputClass(INPUT_CLASS, 'mitarbeiter_strasse')}
                                            />
                                            {renderFieldError('mitarbeiter_strasse')}
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <div>
                                                <label className={LABEL_CLASS} htmlFor="urlaub-mitarbeiter-plz">
                                                    PLZ
                                                </label>
                                                <input
                                                    id="urlaub-mitarbeiter-plz"
                                                    type="text"
                                                    name="plz"
                                                    autoComplete="postal-code"
                                                    inputMode="numeric"
                                                    value={mitarbeiterData.plz}
                                                    onChange={(e) => updateMitarbeiterField('plz', e.target.value)}
                                                    placeholder="12345"
                                                    className={getInputClass(INPUT_CLASS, 'mitarbeiter_plz')}
                                                />
                                                {renderFieldError('mitarbeiter_plz')}
                                            </div>
                                            <div className="sm:col-span-2">
                                                <label className={LABEL_CLASS} htmlFor="urlaub-mitarbeiter-ort">
                                                    Ort
                                                </label>
                                                <input
                                                    id="urlaub-mitarbeiter-ort"
                                                    type="text"
                                                    name="ort"
                                                    autoComplete="address-level2"
                                                    value={mitarbeiterData.ort}
                                                    onChange={(e) => updateMitarbeiterField('ort', e.target.value)}
                                                    placeholder="Musterstadt"
                                                    className={getInputClass(INPUT_CLASS, 'mitarbeiter_ort')}
                                                />
                                                {renderFieldError('mitarbeiter_ort')}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Urlaubskürzung nach § 17 BEEG
                                    </p>
                                    <div className="space-y-4">
                                        <div>
                                            <label className={LABEL_CLASS}>Regulärer Jahresurlaubsanspruch (Tage)</label>
                                            <input
                                                type="number"
                                                min={1}
                                                step={0.5}
                                                value={jahresurlaubTage}
                                                onChange={(e) => {
                                                    setJahresurlaubTage(e.target.value);
                                                    clearFieldError('jahresurlaub_tage');
                                                }}
                                                className={getInputClass(INPUT_CLASS, 'jahresurlaub_tage')}
                                            />
                                            {renderFieldError('jahresurlaub_tage')}
                                        </div>
                                        <p className="text-xs text-pe-muted dark:text-slate-300 leading-relaxed border border-[#E6C299]/25 bg-[#E6C299]/8 rounded-lg px-3 py-3">
                                            {ELTERNZEIT_INFO_HINWEIS}
                                        </p>
                                        <div>
                                            <label className={LABEL_CLASS}>Beginn der Elternzeit</label>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <select
                                                        value={startMonat}
                                                        onChange={(e) => {
                                                            setStartMonat(e.target.value);
                                                            clearFieldError('elternzeit_start_monat');
                                                        }}
                                                        className={getInputClass(INPUT_CLASS, 'elternzeit_start_monat')}
                                                    >
                                                        <option value="">Monat wählen …</option>
                                                        {MONAT_OPTIONS.map((opt) => (
                                                            <option key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {renderFieldError('elternzeit_start_monat')}
                                                </div>
                                                <div>
                                                    <select
                                                        value={startJahr}
                                                        onChange={(e) => {
                                                            setStartJahr(e.target.value);
                                                            clearFieldError('elternzeit_start_jahr');
                                                        }}
                                                        className={getInputClass(INPUT_CLASS, 'elternzeit_start_jahr')}
                                                    >
                                                        <option value="">Jahr wählen …</option>
                                                        {jahrOptions.map((opt) => (
                                                            <option key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {renderFieldError('elternzeit_start_jahr')}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS}>Dauer der Elternzeit</label>
                                            <select
                                                value={dauerOption}
                                                onChange={(e) => {
                                                    setDauerOption(e.target.value as DauerOption);
                                                    clearFieldError('elternzeit_dauer');
                                                    clearFieldError('elternzeit_individuell_monate');
                                                }}
                                                className={getInputClass(INPUT_CLASS, 'elternzeit_dauer')}
                                            >
                                                <option value="">Dauer wählen …</option>
                                                {DAUER_OPTIONS.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {renderFieldError('elternzeit_dauer')}
                                        </div>
                                        {dauerOption === 'individuell' && (
                                            <div>
                                                <label className={LABEL_CLASS}>Anzahl Monate</label>
                                                <input
                                                    type="number"
                                                    min={1}
                                                    step={1}
                                                    value={individuelleMonate}
                                                    onChange={(e) => {
                                                        setIndividuelleMonate(e.target.value);
                                                        clearFieldError('elternzeit_individuell_monate');
                                                    }}
                                                    className={getInputClass(INPUT_CLASS, 'elternzeit_individuell_monate')}
                                                />
                                                {renderFieldError('elternzeit_individuell_monate')}
                                            </div>
                                        )}
                                        <div>
                                            <label className={LABEL_CLASS}>Berechneter Zeitraum (automatisch)</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={
                                                    elternzeitZeitraum
                                                        ? `${formatDisplayDate(elternzeitBeginn)} bis ${formatDisplayDate(elternzeitEnde)} (${elternzeitZeitraum.volleKalendermonateGesamt} volle Kalendermonate)`
                                                        : '—'
                                                }
                                                className={READONLY_INPUT_CLASS}
                                            />
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS}>
                                                Urlaubskürzung je Kalenderjahr (automatisch)
                                            </label>
                                            <textarea
                                                readOnly
                                                rows={Math.max(2, urlaubCalculation?.jahre.length ?? 1)}
                                                value={
                                                    urlaubCalculation
                                                        ? formatUrlaubsjahreSummary(urlaubCalculation.jahre)
                                                        : '—'
                                                }
                                                className={`${READONLY_INPUT_CLASS} resize-none min-h-[72px]`}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Ergänzender Sachverhalt (optional)
                                    </p>
                                    <textarea
                                        value={ergaenzenderFreitext}
                                        onChange={(e) => setErgaenzenderFreitext(e.target.value)}
                                        rows={4}
                                        placeholder="Optionale interne Notizen oder spezifische Absprachen …"
                                        className={`${INPUT_CLASS} resize-y min-h-[100px]`}
                                    />
                                </div>
                            </div>
                        )}

                        {currentStep === 2 && (
                            <div className="w-full min-h-0 pr-2 mb-6">
                                {renderContractDocument()}
                            </div>
                        )}
                    </div>

                    {currentStep === 2 && (
                        <PePapersDisclaimerGate
                            accepted={disclaimerAccepted}
                            onAcceptedChange={setDisclaimerAccepted}
                        />
                    )}

                    <div className="px-6 py-4 border-t border-pe-border dark:border-[#222] shrink-0 print:hidden">
                        <div className="flex flex-wrap gap-3">
                            {currentStep > 1 && (
                                <button
                                    type="button"
                                    onClick={handleZurueck}
                                    className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors"
                                >
                                    Zurück
                                </button>
                            )}

                            {currentStep === 1 ? (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {isSaving && archiveFeedback !== 'draft' ? 'Speichert...' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleWeiter}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-[#E6C299] hover:bg-[#d9b183] dark:hover:bg-white text-black transition-colors"
                                    >
                                        Dokument erstellen
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {archiveFeedback === 'draft' ? 'Gespeichert! ✓' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(false)}
                                        disabled={isActionLocked || isSaving}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-pe-card dark:bg-[#15171e] hover:bg-pe-hover dark:hover:bg-[#1a1d24] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        {isSaving && archiveFeedback !== 'draft'
                                            ? 'Speichert...'
                                            : archiveFeedback === 'success'
                                            ? 'Gespeichert! ✓'
                                            : 'Im Archiv speichern'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleDownloadPdf()}
                                        disabled={isActionLocked || isPdfDownloading}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-gradient-to-b from-[#E6C299] to-[#b48a56] hover:from-[#f0d3b3] hover:to-[#cfa674] text-black transition-colors'
                                        )}
                                    >
                                        {isPdfDownloading ? 'PDF wird erstellt...' : 'Als PDF herunterladen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handlePrintIsolated}
                                        disabled={isActionLocked || isPdfDownloading}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        Drucken
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default UrlaubskuerzungElternzeitModal;
